import * as Yup from "yup";

export const CategorySchema = Yup.object().shape({
  categoryName: Yup.string().required("name is required."),
  subcategory: Yup.array()
  .min(1, "At least one subcategory is required."),
});
